export default __webpack_public_path__ + "static/media/spotMonitoringButton.324932d5.svg";